import { render } from "./pointStudent.vue?vue&type=template&id=9bd07f9a"
import script from "./pointStudent.vue?vue&type=script&lang=js"
export * from "./pointStudent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__